exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".aff-text-color-1{color:#8088d1}.aff-text-color-2{color:#feffff}.aff-text-color-3{color:#566a76}.aff-text-color-4{color:#822f35}.aff-back-color-1{background-color:#1e2127}.aff-back-color-2{background-color:#323c42}.aff-back-color-3{background-color:#1c1f24}.aff-back-color-4{background-color:#8088d1}.aff-back-color-5{background-color:#fff}.aff-back-color-6{background-color:#323c42}.aff-form-field::-webkit-input-placeholder{color:#566a76}.aff-form-field:-moz-placeholder,.aff-form-field::-moz-placeholder{color:#566a76}.aff-form-field:-ms-input-placeholder{color:#566a76}.aff-border-color-1{border:#8088d1!important}.aff-border-color-2{border:#323c42!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/affiliate/css/aff-colors.css
// module id = 149
// module chunks = 4